/* Build Stuff 2026 · The Age of Agency · homepage behaviour (no dependencies) */
(function () {
  'use strict';

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function init(root) {
    if (!root || root.dataset.aoaReady === 'true') return;
    root.dataset.aoaReady = 'true';

    var motionAllowed = root.dataset.motion !== 'false' && !reducedMotion.matches;
    var reveals = root.querySelectorAll('.aoa-reveal');

    /* Scroll reveal + count-up */
    function activate(el) {
      el.classList.add('is-visible');
      if (motionAllowed) el.querySelectorAll('[data-count]').forEach(countUp);
    }

    if (!motionAllowed || !('IntersectionObserver' in window)) {
      reveals.forEach(function (el) { el.classList.add('is-visible'); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          activate(entry.target);
          io.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.1 });
      reveals.forEach(function (el) { io.observe(el); });
    }

    function countUp(el) {
      if (el.dataset.counted === 'true') return;
      el.dataset.counted = 'true';
      var target = parseInt(el.dataset.count, 10);
      if (isNaN(target)) return;
      var start = null;
      var duration = 1100;
      function frame(ts) {
        if (start === null) start = ts;
        var p = Math.min((ts - start) / duration, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = Math.round(target * eased);
        if (p < 1) requestAnimationFrame(frame);
        else el.textContent = target;
      }
      requestAnimationFrame(frame);
    }

    /* Countdown */
    root.querySelectorAll('[data-countdown]').forEach(function (box) {
      var when = Date.parse(box.dataset.countdown);
      if (isNaN(when)) return;
      var f = {
        days: box.querySelector('[data-cd="days"]'),
        hours: box.querySelector('[data-cd="hours"]'),
        minutes: box.querySelector('[data-cd="minutes"]'),
        seconds: box.querySelector('[data-cd="seconds"]')
      };
      function pad(n) { return n < 10 ? '0' + n : String(n); }
      function tick() {
        var diff = Math.max(0, when - Date.now());
        var s = Math.floor(diff / 1000);
        var d = Math.floor(s / 86400);
        var h = Math.floor((s % 86400) / 3600);
        var m = Math.floor((s % 3600) / 60);
        var sec = s % 60;
        if (f.days) f.days.textContent = String(d);
        if (f.hours) f.hours.textContent = pad(h);
        if (f.minutes) f.minutes.textContent = pad(m);
        if (f.seconds) f.seconds.textContent = pad(sec);
        if (diff === 0) clearInterval(timer);
      }
      tick();
      var timer = setInterval(tick, 1000);
      box.setAttribute('aria-label', 'Countdown to the conference');
    });


    /* Highlight video: click-to-play facade (no third-party script until pressed) */
    root.querySelectorAll('[data-aoa-video]').forEach(function (box) {
      var btn = box.querySelector('[data-video-play]');
      var frame = box.querySelector('.aoa-video__frame');
      if (!btn || !frame) return;
      btn.addEventListener('click', function () {
        var id = encodeURIComponent(box.dataset.videoId || '');
        var type = box.dataset.videoType;
        if (!id) return;
        var src = type === 'vimeo'
          ? 'https://player.vimeo.com/video/' + id + '?autoplay=1&dnt=1'
          : 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0&modestbranding=1';
        var iframe = document.createElement('iframe');
        iframe.className = 'aoa-video__embed';
        iframe.src = src;
        iframe.title = btn.getAttribute('aria-label') || 'Video';
        iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
        iframe.setAttribute('allowfullscreen', '');
        iframe.setAttribute('loading', 'lazy');
        frame.appendChild(iframe);
        box.classList.add('is-playing');
        iframe.focus();
      });
    });

    /* Pointer effects (fine pointers only, motion allowed only) */
    var hero = root.querySelector('.aoa-hero');
    var field = root.querySelector('.aoa-hero__field');
    if (hero && field && motionAllowed && window.matchMedia('(pointer: fine)').matches) {
      var raf = null;
      hero.addEventListener('pointermove', function (event) {
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = null;
          var b = hero.getBoundingClientRect();
          var nx = (event.clientX - b.left) / b.width - 0.5;
          var ny = (event.clientY - b.top) / b.height - 0.5;
          field.style.setProperty('--aoa-mx', (nx * 18).toFixed(1) + 'px');
          field.style.setProperty('--aoa-my', (ny * 14).toFixed(1) + 'px');
          field.style.setProperty('--aoa-bx', (nx * -30).toFixed(1) + 'px');
        });
      }, { passive: true });
      hero.addEventListener('pointerleave', function () {
        field.style.removeProperty('--aoa-mx');
        field.style.removeProperty('--aoa-my');
        field.style.removeProperty('--aoa-bx');
      });
    }
  }

  function boot() {
    document.querySelectorAll('[data-aoa]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  /* Shopify theme editor: re-initialise when the section is (re)rendered */
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target && event.target.querySelector('[data-aoa]');
    if (root) init(root);
  });
})();
